const PHONE_ALLOWED_CHARACTERS = /[^0-9+().\s-]/g;
const PHONE_VALID_PATTERN = /^[0-9+().\s-]*$/;

export function sanitizePhoneInput(value: unknown): string {
  return String(value ?? '').replace(PHONE_ALLOWED_CHARACTERS, '');
}

export function isPhoneInputValid(value: unknown): boolean {
  return PHONE_VALID_PATTERN.test(String(value ?? ''));
}

export function phoneInputValidationMessage(label = 'numéro de téléphone'): string {
  return `Le ${label} ne doit contenir que des chiffres, espaces, +, -, points ou parenthèses.`;
}
